import * as React from 'react';
import { Button, StyleRulesCallback, Theme, withStyles, WithStyles } from '@material-ui/core';
import { InjectedFormProps, reduxForm } from 'redux-form';
import { disclosureFormName, DisclosureInitialData, PrivatePersonDisclosureData } from '../../../model/disclosureData';
import PrivatePersonDisclosureFormData from '../components/PrivatePersonRegistrationDisclosureFormData';
import IdentityCardDisclosureFormData from '../components/IdentityCardDisclosureFormData';
import BudgetDisclosureFormData from '../components/BudgetDisclosureFormData';
import BankAccountDisclosureFormData from '../components/BankAccountDisclosureFormData';
import DisclosureErrorDialog from '../components/DisclosureErrorDialog';
import Translator from '../../../components/Translator';

type CssClasses = 'formContainer' | 'submit';
const styles: StyleRulesCallback<CssClasses> = (theme: Theme) => ({
  formContainer: {
    paddingTop: theme.spacing.unit * 4,
  },
  submit: {
    position: 'absolute',
    right: '0px',
    bottom: '0px',
  },
});

interface OwnProps {
  initalData: DisclosureInitialData;
  disclosureId: string;
  onSubmitHandler: (values: PrivatePersonDisclosureData) => Promise<any>;
}

type Props = OwnProps & WithStyles<CssClasses> & InjectedFormProps<PrivatePersonDisclosureData, OwnProps>;

class DisclosureForm extends React.Component<Props> {
  public componentDidMount(): void {
    const initialData = this.props.initalData;
    this.props.change('partner1Salutation', initialData.salutation);
    this.props.change('partner1FirstName', initialData.firstName);
    this.props.change('partner1LastName', initialData.lastName);
    this.props.change('partner1Street', initialData.street);
    this.props.change('partner1HouseNumber', initialData.houseNumber);
    this.props.change('partner1ZipCode', initialData.zipCode);
    this.props.change('partner1City', initialData.city);
    this.props.change('partner1Phonenumber', initialData.phone);
    this.props.change('partner1Mail', initialData.email);
    this.props.change('partner1IdentityCardType', initialData.identityCardType);
    this.props.change('partner1IdentityCardNumber', initialData.identityCardNumber);
    this.props.change('partner1IdentityCardIssuedOn', initialData.identityCardIssuedOn);
    this.props.change('partner1IdentityCardIssuePlace', initialData.identityCardIssuedPlace);

    // this.props.change('partner1Title', 'Herr');
    // this.props.change('partner1FirstName', 'Vorname');
    // this.props.change('partner1LastName', 'Nachname');
    // this.props.change('partner1Street', 'Strasse');
    // this.props.change('partner1HouseNumber', 'Nr');
    // this.props.change('partner1ZipCode', '12364');
    // this.props.change('partner1City', 'Stadt');
    // this.props.change('partner1RegisterAddress', '0');
    // this.props.change('partner1Nationality', 'DE');
    // this.props.change('partner1Mail', 'Email');
    // this.props.change('partner1Phonenumber', 'Telfon');
    // this.props.change('partner1MaritalStatus', '0');
    // this.props.change('partner1JobType', '0');
    // this.props.change('partner1AlimonyPersons', '1');
    // this.props.change('partner1AlimonyChildren', '2');
    // this.props.change('partner1IdentityCardType', '0');
    // this.props.change('partner1IdentityCardNumber', 'Ident123');
    // this.props.change('partner1IdentityCardIssuePlace', 'Austellort');
    // this.props.change('partner1IdentityCardIssueAgency', 'Behoerde');
    // this.props.change('partner1IdentityCardIssuedOn', '2018-01-01');
    // this.props.change('partner1IdentityCardExpirationDate', '2018-01-02');
    // this.props.change('partner1DateOfBirth', '2018-01-02');
    // this.props.change('partner1CountryOfBirth', 'GebLand');
    // this.props.change('partner1PlaceOfBirth', 'GebStadt');
    // this.props.change('partner1NetIncome', '123,45');
    // this.props.change('partner1AdditionalIncome', '678,98');
    // this.props.change('partner1ProbationaryPeriod', '0');
    // this.props.change('partner1FixedTermEmploymentContract', '0');
    // this.props.change('partner1EmploymentContractEndStamp', '');
    // this.props.change('partner1NoUSCitizen', '');
    // this.props.change('bankAccountOwner', 'Bank');
    // this.props.change('partner1QualityQuestion1', '1');
    // this.props.change('partner1QualityQuestion2', '1');
    // this.props.change('partner1QualityQuestion3', '1');
    // this.props.change('iban', 'Iban');
  }

  render() {
    const { classes, handleSubmit, onSubmitHandler, error } = this.props;

    return (
      <Translator>
        {translate => {
          return (
            <>
              {error != null && <DisclosureErrorDialog error={error} />}
              <form onSubmit={handleSubmit(onSubmitHandler)}>
                <div className={classes.formContainer}>
                  <PrivatePersonDisclosureFormData />
                </div>
                <div className={classes.formContainer}>
                  <IdentityCardDisclosureFormData />
                </div>
                <div className={classes.formContainer}>
                  <BudgetDisclosureFormData />
                </div>
                <div className={classes.formContainer}>
                  <BankAccountDisclosureFormData />
                </div>
                <div style={{ position: 'relative', height: '80px' }}>
                  <Button
                    disabled={this.props.submitting}
                    variant={'contained'}
                    color={'primary'}
                    className={classes.submit}
                    type={'submit'}
                  >
                    {translate('disclosureSubmitButtonText')}
                  </Button>
                </div>
              </form>
            </>
          );
        }}
      </Translator>
    );
  }
}

export default reduxForm<PrivatePersonDisclosureData, OwnProps>({ form: disclosureFormName })(
  withStyles(styles)(DisclosureForm)
);



// WEBPACK FOOTER //
// ./src/routes/disclosure/container/DisclosureForm.tsx